<template>
	<li class="permission-set">
		<span class="permission-set__header">
			{{ data.groupName }}
		</span>
		<span class="permission-set__content">
			{{ data.permissionName }}
		</span>
	</li>
</template>
<script>
export default {
	name: 'PermissionSet',
	props: {
		data: {
			type: Object,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>
.permission-set {
	display: inline-flex;
	flex-direction: column;
	align-items: flex-start;
	color: $black;
	text-transform: capitalize;

	&__header {
		font-weight: $medium-font-weight;
		padding-bottom: $padding-sm;		
	}
}
</style>
